import React from "react";
import BondPlayInfoModal from "./BondPlayInfoModal";
import { formatCoinFlipCoin } from "../../utils/coinFlipHelpers";
import {
  COIN_POOL_FILL_MODE_DESC,
  COIN_POOL_FILL_MODE_LABEL,
  formatCoinPoolCoin,
} from "../../utils/coinPoolHelpers";

const DEFAULT_POOL_CONSTANTS = {
  minStakeCoin: 100,
  platformFeeRate: 0.05,
  lobbySeconds: 300,
};

const DEFAULT_FLIP_CONSTANTS = {
  minStake: 100,
  maxStake: 500_000,
  odds: 2,
  platformFeeRate: 0.05,
  pendingPlayTtlMs: 60_000,
};

const BondCoinInfoModal = ({
  open = false,
  onClose,
  mode = "pool",
  poolConstants = DEFAULT_POOL_CONSTANTS,
  flipConstants = DEFAULT_FLIP_CONSTANTS,
}) => {
  if (mode === "flip") {
    const minStake = flipConstants?.minStake || DEFAULT_FLIP_CONSTANTS.minStake;
    const maxStake = flipConstants?.maxStake || DEFAULT_FLIP_CONSTANTS.maxStake;
    const odds = flipConstants?.odds || DEFAULT_FLIP_CONSTANTS.odds;
    const platformFee = Math.round((flipConstants?.platformFeeRate || 0.05) * 100);
    const playSeconds = Math.round(
      (flipConstants?.pendingPlayTtlMs || DEFAULT_FLIP_CONSTANTS.pendingPlayTtlMs) / 1000
    );

    return (
      <BondPlayInfoModal
        open={open}
        onClose={onClose}
        titleId="bplay-coin-flip-info-title"
        title="Coin Flip"
        subtitle="Instant head-or-tail flips backed by the investor pool."
        sections={[
          {
            title: "Reserve a flip",
            items: [
              <>Pick <strong>Head</strong> or <strong>Tail</strong> and stake {formatCoinFlipCoin(minStake)}–{formatCoinFlipCoin(maxStake)} COIN.</>,
              <>The investor pool covers your max win at {odds}× gross payout.</>,
            ],
          },
          {
            title: "Flip in time",
            items: [
              <>After reserving, tap <strong>Flip</strong> within {playSeconds} seconds or your stake is refunded.</>,
              <>Cancel anytime before flipping for a full refund.</>,
            ],
          },
          {
            title: "Result",
            items: [
              <>If your side lands, you win from the pool. If not, your stake goes to investors.</>,
              <>Platform fee ({platformFee}%) applies to player profit on wins.</>,
            ],
          },
        ]}
      />
    );
  }

  const minStake = poolConstants?.minStakeCoin ?? DEFAULT_POOL_CONSTANTS.minStakeCoin;
  const platformFee = Math.round((poolConstants?.platformFeeRate || 0.05) * 100);
  const lobbyMinutes = Math.round(
    (poolConstants?.lobbySeconds || DEFAULT_POOL_CONSTANTS.lobbySeconds) / 60
  );

  return (
    <BondPlayInfoModal
      open={open}
      onClose={onClose}
      titleId="bplay-coin-pool-info-title"
      title="Coin Pool"
      subtitle="Post Head or Tail orders on the book — matched stakes enter the shared pool toss."
      sections={[
        {
          title: "Place orders",
          items: [
            <>Pick a side and post COIN on the order book. Your order matches against the opposite side.</>,
            <>Minimum order {formatCoinPoolCoin(minStake)} COIN. COIN is reserved until matched or cancelled.</>,
          ],
        },
        {
          title: "Fill & cancel",
          items: [
            <>
              <strong>{COIN_POOL_FILL_MODE_LABEL.partial}</strong> — {COIN_POOL_FILL_MODE_DESC.partial}.
            </>,
            <>
              <strong>{COIN_POOL_FILL_MODE_LABEL.exact}</strong> — {COIN_POOL_FILL_MODE_DESC.exact}.
            </>,
            <>Cancel open orders anytime for a refund of unmatched COIN.</>,
          ],
        },
        {
          title: "Toss & payout",
          items: [
            <>When both sides have matched players, the book closes and the coin tosses (about every {lobbyMinutes} min).</>,
            <>Winners split the pool by stake share. Platform fee ({platformFee}%) applies to gross winnings.</>,
          ],
        },
      ]}
    />
  );
};

export default BondCoinInfoModal;
